import { useRef, useEffect } from 'react';
//import styles from './SpeedSlider.module.css';
import styles from '../../Assets/Styles/Joystick/SpeedSlider.module.css';

const PRESETS = [
  { label: 'STOP', value: 0   },
  { label: '25%',  value: 64  },
  { label: '50%',  value: 128 },
  { label: '75%',  value: 192 },
  { label: 'MAX',  value: 255 },
];

export default function SpeedSlider({ speed, onChange }) {
  const trackRef = useRef(null);
  const dragging = useRef(false);

    const calc = (e) => {
    //alert(e);
    const rect  = trackRef.current.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    //alert(clientX);
    const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    //alert(Math.round(ratio * 255));
    return Math.round(ratio * 255);
  };

  const onDown = (e) => { dragging.current = true; onChange(calc(e)); };
  const onMove = (e) => { if (dragging.current) { e.preventDefault(); onChange(calc(e)); } };
  const onUp   = ()  => { dragging.current = false; };

  useEffect(() => {
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup',   onUp);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend',  onUp);
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup',   onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend',  onUp);
    };
  }, []);

  const pct = (speed / 255) * 100;
  const hue = Math.round(pct * 1.2); // 0 → cyan-ish, 100 → green
  const kmperhours = ((speed / 255) * 1.28)
  const meterperhours = Math.round(kmperhours * 1000)
  return (
    <div className={styles.wrap}>
      <div className={styles.header}>
        <span className={styles.title}>▶ SPEED</span>
        <div className={styles.valueWrap}>
          <span className={styles.value}>{speed}</span>
                  <span className={styles.unit}> / 255 ({meterperhours} m/hr)</span>
        </div>
      </div>

      <div
        className={styles.track}
        ref={trackRef}
        onMouseDown={onDown}
        onTouchStart={onDown}
      >
        <div className={styles.fill} style={{ width: `${pct}%` }} />
        {Array.from({ length: 17 }, (_, i) => (
          <div key={i} className={styles.tick} style={{ left: `${(i / 16) * 100}%` }} />
        ))}
        <span className={styles.trackLabel}>MAX: 255</span>
      </div>

      <div className={styles.presets}>
        {PRESETS.map(({ label, value }) => (
          <button
            key={value}
            className={`${styles.preset} ${speed === value ? styles.presetActive : ''}`}
            onClick={() => onChange(value)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
